import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('payment');

export class CardsConfiguration extends Api {
  constructor(http, config = {}) {
    super(http, url, 'cardsConfiguration', config);
  }

  async getCards(config = {}) {
    config = { ...this._config, ...config };
    return this._http.get(`${this._baseUrl}/cards`, {}, config);
  }

  async getAccounts(onlyActive, config = {}) {
    config = { ...this._config, ...config };
    return this._http.get(`${this._baseUrl}/accounts`, {
      params: { onlyActive },
    }, config);
  }

  async getBanks(config = {}) {
    config = { ...this._config, ...config };
    return this._http.get(`${this._baseUrl}/banks`, {}, config);
  }

  async getCardConfiguration(id, config = {}) {
    config = { ...this._config, ...config };
    return this._http.get(`${this._baseUrl}/cardsConfiguration/${id}`, config);
  }

  async createCardConfiguration(config = {}) {
    config = { ...this._config, ...config };
    return this._http.post(`${this._baseUrl}/cardsConfiguration`, config)
  }

  async updateCardConfiguration(id, instance, config = {}) {
    config = { ...this._config, ...config };
    return this._http.put(`${this._baseUrl}/cardsConfiguration/${id}`, instance, config)
  }
}